export const SEGMENT_DEPLOYABLE_NAME = 'cc-shopping-client';
export const SEGMENT_DEPLOYABLE_VERSION = '1.0.0';
export const DEFAULT_SEGMENT_SKU_VIEWED_SOURCE = 'marketplace';
export const DEFAULT_SEGMENT_SKU_VIEWED_PRODUCT_TYPE = 'credit_cards';
export const DEFAULT_SEGMENT_SKU_VIEWED_LEVEL = 'offer';
export const SEGMENT_SKU_VIEWED_SOURCE = DEFAULT_SEGMENT_SKU_VIEWED_SOURCE;
export const SEGMENT_SKU_VIEWED_PRODUCT_TYPE = DEFAULT_SEGMENT_SKU_VIEWED_PRODUCT_TYPE;
export const SEGMENT_SKU_VIEWED_LEVEL = DEFAULT_SEGMENT_SKU_VIEWED_LEVEL;
export const SEGMENT_CONTENT_SOURCE = 'wp';
